import { useEffect, useState } from 'react'
import { getClientEnvironment } from '../utils/environment'

type Params = {
  as: React.ElementType
  locale: string
}

const CookieScript = ({ as, locale }: Params) => {
  const Script = as
  const [environment, setEnvironment] = useState('')

  useEffect(() => {
    setEnvironment(getClientEnvironment())
  }, [])

  if (!environment) return null
  if (!(environment.includes('prod') || environment.includes('uat') || environment.includes('dev'))) return <></>
  return (
    <Script
      id="CookieConsentConfig"
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `
          var cassieLoaderScript = document.createElement("script");
          var cdnUrl = "https://cscript-cdn-irl".concat(
            "${environment}" === "prod" ? "" : "-uat",
            ".cassiecloud.com/loader.js"
          );
          cassieLoaderScript.src = cdnUrl;
          document.head.appendChild(cassieLoaderScript);

          var cassieSettings = {
            widgetProfileId: 1,
            languageCode: "${locale}",
            licenseKey: "${environment === 'prod' ? '0418D1C9-468D-4808-AC14-818D15F40C8A' : '951BB4A5-2E2C-4F9F-95B4-13F6F279030B'}",
            region: "irl",
            environment: "${environment === 'prod' ? 'production' : 'uat'}",
          };

          new Promise(function (resolve, reject) {
            cassieLoaderScript.onload = function () {
              if (typeof CassieWidgetLoaderModule !== "undefined") {
                window.CassieWidgetLoader = new CassieWidgetLoaderModule(cassieSettings);
                document.addEventListener("CassieTemplateInitialized", function () {
                  addStrictlyNecessaryToggleSwitch();
                  autoToggleBasedOnConsent();
                });
                function addStrictlyNecessaryToggleSwitch() {
                  var strictlyNecessaryGroup = document.getElementById(
                    "cassie_strictly_necessary"
                  );
                  var strictlyNecessaryGroupHeader = strictlyNecessaryGroup.querySelector(
                    ".cassie-cookie-modal--group-head-container"
                  );
                  var strictlyNecessarySwitch = document.createElement("div");
                  strictlyNecessarySwitch.classList.add(
                    "cassie-toggle-switch",
                    "cassie-cookie-group--toggle-switch"
                  );
                  strictlyNecessarySwitch.role = "switch";
                  strictlyNecessarySwitch.disabled = true;
                  strictlyNecessarySwitch.ariaDisabled = true;
                  strictlyNecessarySwitch.checked = true;
                  strictlyNecessaryGroupHeader.insertBefore(
                    strictlyNecessarySwitch,
                    strictlyNecessaryGroupHeader.children[1]
                  );
                  var strictlyNecessarySwitchSlider = document.createElement("span");
                  strictlyNecessarySwitchSlider.classList.add(
                    "cassie-toggle-switch--slider",
                    "cassie-cookie-group--toggle-switch--slider",
                    "cassie-toggle-switch--slider--active"
                  );
                  strictlyNecessarySwitch.appendChild(strictlyNecessarySwitchSlider);
                  // prevent accept all from toggling the new toggle switch off
                  var acceptAllToggleSwitch = document.getElementById(
                    "cassie_accept_all_toggle_switch"
                  );
                  acceptAllToggleSwitch.addEventListener("click", function () {
                    strictlyNecessarySwitchSlider.classList.add(
                      "cassie-toggle-switch--slider--active"
                    );
                    strictlyNecessarySwitch.checked = true;
                  });
                }
                function autoToggleBasedOnConsent() {
                  var hasConsent = CassieWidgetLoader.Widget.widgetTemplate.hasConsent;
                  if (!hasConsent) {
                    var allToggles = document.querySelectorAll(
                      ".cassie-child-cookie--toggle-switch--slider"
                    );
                    allToggles.forEach((toggle) => {
                      toggle.classList.add("cassie-toggle-switch--slider--active");
                    });
                  }
                }
              }
              resolve();
            };
            cassieLoaderScript.onerror = function () {
              console.log("Cassie has failed to load.");
              reject();
            };
          });
        `,
      }}
    />
  )
}

export default CookieScript
